import dayjs from 'dayjs';

export const [todayDate] = new Date().toISOString().split('T');
export const dateFormatList = ['DD.MM.YYYY', 'YYYY-MM-DD'];
export const initialDate = dayjs(todayDate, dateFormatList[1]);
